/* eslint-disable arrow-body-style */
import axios from 'axios';
import common from '~/common';
import { logError } from '~/common/utils';
import excel from '~/skills/excel';
const developIp = `${common.Ip.Actions}/v2`;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const wind_id = () => localStorage.getItem('Wind_ID');
const wind_name = () => localStorage.getItem('Wind_Name');

///
const clearKey = (dispatch, { key = '' }) => dispatch({ type: 'clear', label: key });
const setLoading = value => ({ type: 'loading_add', value });
const removeLoading = value => ({ type: 'loading_del', value });
const getWindIdDetail = (dispatch, { id }) => {
  const key = 'WindIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/windcontract/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindIdDetail');
      dispatch(removeLoading(key));
    });
};

// 風場合約管理
const getWindManagementList = (dispatch, { page, per_page, body }) => {
  const key = 'WindManagementList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/windcontract/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindManagementList');
      dispatch(removeLoading(key));
    });
};

const getWMGroupList = (dispatch) => {
  const key = "WMGroupList";
  dispatch(setLoading(key));

  const payload = {
    keyword: "",
    page_index: 0,
    page_size: 100,
  };

  axios
    .post(
      `${developIp}/windcontract/groups/page_index/page_size/list/`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...getHeaders().headers,
        },
      }
    )
    .then((res) => {
      if (res.data.status === 200 || res.data.status === "200") {
        const list = res.data.data || [];

        // 前端轉換：group_name → name, 加 value
        const mapped = list.map((item) => ({
          id: item.id,
          name: item.group_name,
          value: item.id,
        }));

        dispatch({ type: "post", body: mapped, label: key });
      }

      dispatch(removeLoading(key));
    })
    .catch((error) => {
      logError(error, "getWMGroupList");
      dispatch(removeLoading(key));
    });
};

// 舊版 20251124
// 結構: { name, value }
// const getWMGroupList = dispatch => {
//   const key = 'WMGroupList';
//   dispatch(setLoading(key));
//   axios.get(`${developIp}/code/windcontract/`, getHeaders())
//     .then(res => {
//       if (res.data.status === '200') {
//         dispatch({ type: 'post', body: res.data.data, label: key });
//       }
//     })
//     .catch(error => {
//       logError(error, 'getWMGroupList');
//       dispatch(removeLoading(key));
//     });
// };

const postAddNewWindManagement = (dispatch, { body }) => {
  const key = 'PostAddNewWindManagement';
  dispatch(setLoading(key));
  axios.post(`${developIp}/windcontract/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewWindManagement');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getWindManagementIdDetail = (dispatch, { id }) => {
  const key = 'WindManagementIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/windcontract/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindManagementIdDetail');
      dispatch(removeLoading(key));
    });
};
const putWindManagementIdDetail = (dispatch, { id, body }) => {
  const key = 'PutWindManagementIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/windcontract/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putWindManagementIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteWindManagement = (dispatch, { id }) => {
  const key = 'DeleteWindManagement';
  dispatch(setLoading(key));
  axios.put(`${developIp}/windcontract/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteWindManagement');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const WindManagement = {
  getWindManagementList,
  getWMGroupList,
  postAddNewWindManagement,
  getWindManagementIdDetail,
  putWindManagementIdDetail,
  deleteWindManagement,
};
// 基本資料
const getBIBasicInfo = (dispatch, { windId }) => { // 程序文件
  const key = 'BIBasicInfo';
  dispatch(setLoading(key));
  axios.get(`${developIp}/contract/windcontract/${windId || wind_id()}/report/1/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBIBasicInfo');
      dispatch(removeLoading(key));
    });
};
const getBIPWind = (dispatch, { windId }) => {
  const key = 'BIPWind';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/windcontract/${windId || wind_id()}/view/1/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBIPWind');
      dispatch(removeLoading(key));
    });
};
const getBIPTransport = (dispatch, { windId }) => {
  const key = 'BIPTransport';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/windcontract/${windId || wind_id()}/view/2/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBIPTransport');
      dispatch(removeLoading(key));
    });
};
const getBIPItem = (dispatch, { windId }) => {
  const key = 'BIPItem';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/windcontract/${windId || wind_id()}/view/3/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBIPItem');
      dispatch(removeLoading(key));
    });
};
const getBIPOEquity = (dispatch, { windId }) => {
  const key = 'BIPOEquity';
  dispatch(setLoading(key));
  axios.post(`${developIp}/equitychange/list/${1}/${10}/`, {
    windcontract_id: windId || wind_id(),
    sort: 'desc',
    sort_field: 'upd_time',
  }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const data = res.data?.data?.list?.[0]?.original_equity;
        dispatch({ type: 'post', body: data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBIPOEquity');
      dispatch(removeLoading(key));
    });
};

const getBIPCEquity = (dispatch, { windId }) => {
  const key = 'BIPCEquity';
  dispatch(setLoading(key));
  axios.post(`${developIp}/equitychange/list/${1}/${10}/`, {
    windcontract_id: windId || wind_id(),
    sort: 'desc',
    sort_field: 'upd_time',
  }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const data = res.data?.data?.list?.[0];
        if (!data) {
          dispatch(removeLoading(key));
        } else {
          dispatch({ type: 'post', body: data, label: key });
        }
      }
    })
    .catch(error => {
      logError(error, 'getBIPCEquity');
      dispatch(removeLoading(key));
    });
};

const BasicInfo = { getBIBasicInfo, getBIPWind, getBIPTransport, getBIPItem, getBIPOEquity, getBIPCEquity };

// 契約內容
const getACompanyTypeList = dispatch => { // 程序文件
  const key = 'ACompanyTypeList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/company_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getACompanyTypeList');
      dispatch(removeLoading(key));
    });
};
const getABidItemList = dispatch => { // 程序文件
  const key = 'ABidItemList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/bid_item/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getABidItemList');
      dispatch(removeLoading(key));
    });
};
const getAConnPointList = dispatch => { // 程序文件
  const key = 'AConnPointList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/conn_point/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAConnPointList');
      dispatch(removeLoading(key));
    });
};
const getACDefaultList = dispatch => { // 違約項目
  const key = 'ACDefaultList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/break_item/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getACDefaultList');
      dispatch(removeLoading(key));
    });
};
const getAContractData = dispatch => {
  const key = 'AContractData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/contract/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAContractData');
      dispatch(removeLoading(key));
    });
};
const postAddNewAContractData = (dispatch, { body }) => {
  const key = 'PostAddNewAContractData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/contract/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewAContractData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putAContractData = (dispatch, { id, body }) => {
  const key = 'PutAContractData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/contract/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putAContractData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const AContract = {
  getACompanyTypeList,
  getABidItemList,
  getAConnPointList,
  getACDefaultList,
  getAContractData,
  postAddNewAContractData,
  putAContractData,
};
// 行政程序
const getAProList = (dispatch, { page, per_page, body, windId }) => {
  const key = 'AProList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/adminproc/list/${page}/${per_page}/`, { windcontract_id: windId || wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAProList');
      dispatch(removeLoading(key));
    });
};
const getAProTypeList = dispatch => { // 程序文件
  const key = 'AProTypeList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/proc_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAProTypeList');
      dispatch(removeLoading(key));
    });
};
const getAProApplyStatusList = dispatch => { // 申請狀態
  const key = 'AProApplyStatusList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/proc_apply_status/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAProApplyStatusList');
      dispatch(removeLoading(key));
    });
};
const getAProUnderWaterList = dispatch => { // 水下基礎型式
  const key = 'AProUnderWaterList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/underwater_base_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAProUnderWaterList');
      dispatch(removeLoading(key));
    });
};
const getAProIdDetail = (dispatch, { id }) => {
  const key = 'AProIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/adminproc/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAProIdDetail');
      dispatch(removeLoading(key));
    });
};
const putAProIdDetail = (dispatch, { id, body }) => {
  const key = 'PutAProIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/adminproc/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putAProIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const APro = {
  getAProList,
  getAProTypeList,
  getAProApplyStatusList,
  getAProUnderWaterList,
  getAProIdDetail,
  putAProIdDetail,
};
// 金融項目
const getAFincStatusList = dispatch => { // 國內金融機構融資到位進度
  const key = 'AFincStatusList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/financing_status/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincStatusList');
      dispatch(removeLoading(key));
    });
};
const getAFincDomInsList = dispatch => { // 國內保險機構
  const key = 'AFincDomInsList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/financing_domestic_insurance/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincDomInsList');
      dispatch(removeLoading(key));
    });
};
const getAFincDomBankList = dispatch => { // 國內銀行
  const key = 'AFincDomBankList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/financing_domestic_bank/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincDomBankList');
      dispatch(removeLoading(key));
    });
};
const getAFincBankList = dispatch => { // 國外金融機構
  const key = 'AFincBankList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/financing_bank/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincBankList');
      dispatch(removeLoading(key));
    });
};
const getAFincCreditList = dispatch => { // 國外信貸
  const key = 'AFincCreditList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/financing_credit/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincCreditList');
      dispatch(removeLoading(key));
    });
};
const getAFincData = dispatch => {
  const key = 'AFincData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/financeitem/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAFincData');
      dispatch(removeLoading(key));
    });
};
const postAddNewAFincData = (dispatch, { body }) => {
  const key = 'PostAddNewAFincData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/financeitem/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewAFincData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putAFincData = (dispatch, { body, id }) => { // ID待修改
  const key = 'PutAFincData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/financeitem/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putAFincData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const AFinc = {
  getAFincStatusList,
  getAFincDomInsList,
  getAFincDomBankList,
  getAFincBankList,
  getAFincCreditList,
  getAFincData,
  postAddNewAFincData,
  putAFincData,
};
// 股權變更
const getAEquityList = (dispatch, { page, per_page, body }) => {
  const key = 'AEquityList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/equitychange/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAEquityList');
      dispatch(removeLoading(key));
    });
};
const postAddNewAEquity = (dispatch, { body }) => {
  const key = 'PostAddNewAEquity';
  dispatch(setLoading(key));
  axios.post(`${developIp}/equitychange/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewAEquity');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getAEquityIdDetail = (dispatch, { id }) => {
  const key = 'AEquityIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/equitychange/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAEquityIdDetail');
      dispatch(removeLoading(key));
    });
};
const putAEquityIdDetail = (dispatch, { id, body }) => {
  const key = 'PutAEquityIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/equitychange/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putAEquityIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteAEquity = (dispatch, { id }) => {
  const key = 'DeleteAEquity';
  dispatch(setLoading(key));
  axios.put(`${developIp}/equitychange/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteAEquity');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const AEquity = {
  getAEquityList,
  postAddNewAEquity,
  getAEquityIdDetail,
  putAEquityIdDetail,
  deleteAEquity,
};
// 展延資訊
const getExtendList = (dispatch, { page, per_page, body }) => {
  const key = 'ExtendList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/extendapply/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendList');
      dispatch(removeLoading(key));
    });
};
const getExtendSupReason = dispatch => { // 補件原因
  const key = 'ExtendSupReason';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/supple_reason/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendSupReason');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getExtendTarget = dispatch => { // 展延標的
  const key = 'ExtendTarget';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/extend_target/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendTarget');
      dispatch(removeLoading(key));
    });
};
const getExtendTargetText = dispatch => { // 展延標的
  const key = 'ExtendTargetText';
  dispatch(setLoading(key));
  axios.get(`${developIp}/extendapply/windcontract/${wind_id()}/items`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendTargetText');
      dispatch(removeLoading(key));
    });
};
const getExtendReason = dispatch => { // 展延事由
  const key = 'ExtendReason';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/extend_reason/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendReason');
      dispatch(removeLoading(key));
    });
};
const getExtendRule = dispatch => { // 展延款次
  const key = 'ExtendRule';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/extend_rule/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendRule');
      dispatch(removeLoading(key));
    });
};
const postAddNewExtend = (dispatch, { body }) => {
  const key = 'PostAddNewExtend';
  dispatch(setLoading(key));
  axios.post(`${developIp}/extendapply/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewExtend');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getExtendIdDetail = (dispatch, { id }) => {
  const key = 'ExtendIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/extendapply/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getExtendIdDetail');
      dispatch(removeLoading(key));
    });
};
const putExtendIdDetail = (dispatch, { id, body }) => {
  const key = 'PutExtendIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/extendapply/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putExtendIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteExtend = (dispatch, { id }) => {
  const key = 'DeleteExtend';
  dispatch(setLoading(key));
  axios.put(`${developIp}/extendapply/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteExtend');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const Extend = {
  getExtendList,
  getExtendSupReason,
  getExtendTarget,
  getExtendTargetText,
  getExtendReason,
  getExtendRule,
  postAddNewExtend,
  getExtendIdDetail,
  putExtendIdDetail,
  deleteExtend,
};
// 碼頭系統
const getPSPierList = dispatch => {
  const key = 'PSPierList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/port/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        const data = res.data.data || [];
        for (let i = 1; i <= data.length; i++) {
          const idList = (await getPSPierNumList(i)) || [];
          data[i - 1].idList = idList;
        }
        dispatch({ type: 'post', body: data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPSPierList');
      dispatch(removeLoading(key));
    });
};
const getPSPierNumList = num => {
  return new Promise((resolve, reject) => {
    axios.get(`${developIp}/code/items/port_num_${num}/`, getHeaders())
      .then(res => {
        if (res.data.status === '200') {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        logError(error, 'getPSPierNumList');
        reject(new Error('getPSPierNumList() rejected!'));
      });
  });
};
const getPSRent = dispatch => {
  const key = 'PSRent';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/lessor/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPSRent');
      dispatch(removeLoading(key));
    });
};
const getPSData = dispatch => {
  const key = 'PSData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPSData');
      dispatch(removeLoading(key));
    });
};
const postAddNewPSData = (dispatch, { body }) => {
  const key = 'PostAddNewPSData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/docksys/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewPSData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putPSData = (dispatch, { id, body }) => {
  const key = 'PutPSData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/docksys/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putPSData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const PierSystem = {
  getPSPierList,
  getPSPierNumList,
  getPSRent,
  getPSData,
  postAddNewPSData,
  putPSData,
};
// 工程進度
const getProjectProgressList = (dispatch, { page, per_page, body }) => {
  const key = 'ProjectProgressList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projectplan/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getProjectProgressList');
      dispatch(removeLoading(key));
    });
};
const getPPPlanProjectList = dispatch => {
  const key = 'PPPlanProjectList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/proj_item/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPPlanProjectList');
      dispatch(removeLoading(key));
    });
};

const getPPPlanProjectListV2 = dispatch => {
  const key = 'PPPlanProjectListV2';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projectplan/items/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200' || res.data.status === 200) {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPPlanProjectListV2');
      dispatch(removeLoading(key));
    });
};

const getPPPlanFirstList = dispatch => {
  const key = 'PPPlanFirstList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/proj_port/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        const data = res.data.data || [];
        for (let i = 1; i <= data.length; i++) {
          const idList = (await getPSPierNumList(i)) || [];
          data[i - 1].idList = idList;
        }
        dispatch({ type: 'post', body: data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPPlanFirstList');
      dispatch(removeLoading(key));
    });
};
const getPPPlanSecondList = dispatch => {
  const key = 'PPPlanSecondList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/proj_nation/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPPlanSecondList');
      dispatch(removeLoading(key));
    });
};
const postAddNewProjectProgress = (dispatch, { body }) => {
  const key = 'PostAddNewProjectProgress';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projectplan/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewProjectProgress');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getProjectProgressIdDetail = (dispatch, { id }) => {
  const key = 'ProjectProgressIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projectplan/${id}/detail/new/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getProjectProgressIdDetail');
      dispatch(removeLoading(key));
    });
};
const putProjectProgressIdDetail = (dispatch, { id, body }) => {
  const key = 'PutProjectProgressIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projectplan/${id}/update/new/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putProjectProgressIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteProjectProgress = (dispatch, { id }) => {
  const key = 'DeleteProjectProgress';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projectplan/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteProjectProgress');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const ProjectProgress = {
  getProjectProgressList,
  getPPPlanProjectList,
  getPPPlanProjectListV2,
  getPPPlanFirstList,
  getPPPlanSecondList,
  postAddNewProjectProgress,
  getProjectProgressIdDetail,
  putProjectProgressIdDetail,
  deleteProjectProgress,
};
// 每日進度
const getPPDailyList = (dispatch, { body, windId }) => {
  const key = 'PPDailyList';
  const pageIndex = 0;
  const pageSize = 10;
  dispatch(setLoading(key));
  axios.post(`${developIp}/dailyplan/list/date_range/new/v2/`, { windcontract_id: windId || wind_id(), ...body }, getHeaders())
    // axios.post(`${developIp}/dailyplan/list/date_range`, { windcontract_id: windId || wind_id(), ...body }, getHeaders())
    // axios.post(`${developIp}/dailyplan/page_index/${pageIndex}/page_size/${pageSize}/list/new/`, { windcontract_id: windId || wind_id(), sort_method: 'asc', ...body }, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPDailyList');
      dispatch(removeLoading(key));
    });
};

const getPPDailyBoatList = dispatch => {
  const key = 'PPDailyBoatList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/dailyplan/ship`, { windcontract_id: wind_id() }, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        dispatch({ type: 'post', body: list.map(o => ({ name: o.ship_name, value: o.id })), label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPDailyBoatList');
      dispatch(removeLoading(key));
    });
};
const getPPDailySeatList = dispatch => {
  const ary = []; let i = 1;
  while (i <= 200) {
    ary.push({ name: i.toString(), value: i.toString() });
    i += 1;
  }
  dispatch({ type: 'post', body: ary, label: 'PPDailySeatList' });
};
const postAddNewPPDaily = (dispatch, { body }) => {
  const key = 'PostAddNewPPDaily';
  dispatch(setLoading(key));
  axios.post(`${developIp}/dailyplan/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewPPDaily');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getPPDailyIdDetail = (dispatch, { id }) => {
  const key = 'PPDailyIdDetail';
  dispatch(setLoading(key));
  // axios.get(`${developIp}/dailyplan/${id}/detail`, getHeaders())
  axios.get(`${developIp}/dailyplan/${id}/detail/new/v2/`, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        dispatch({ type: 'post', body: { ...res.data.data, 'id': id }, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPDailyIdDetail');
      dispatch(removeLoading(key));
    });
};
const getPPDailyPreIdDetail = (dispatch, { id }) => {
  const key = 'PPDailyPreIdDetail';
  dispatch(setLoading(key));
  axios.post(
    `${developIp}/dailyplan/preprocess/${id}`,
    {
      zone_name_list: [
        'z1',
        'z2',
        'z3',
        'z4',
      ],
    },
    getHeaders(),
  )
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPDailyPreIdDetail');
      dispatch(removeLoading(key));
    });
};

const putPPDailyIdDetailV2 = (dispatch, { body }) => {
  const key = 'putPPDailyIdDetailV2';
  dispatch(setLoading(key));
  axios.put(`${developIp}/dailyplan/detail/update/new/v2/`, body, getHeaders())
    .then(res => {
      console.log(res);
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putPPDailyIdDetailV2');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};

const putPPDailyIdDetail = (dispatch, { id, body }) => {
  const key = 'PutPPDailyIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/dailyplan/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putPPDailyIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};

const deletePPDaily = (dispatch, { id }) => {
  const key = 'DeletePPDaily';
  dispatch(setLoading(key));
  axios.put(`${developIp}/dailyplan/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deletePPDaily');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const exportPPDailyIdDetail = ({ id, type, preId }) => {
  axios.get(`${developIp}/dailyplan/export/${id}/${type}/${preId}/excel/path`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        window.location.assign(res.data.data.path);
      }
    })
    .catch(error => {
      logError(error, 'exportPPDailyIdDetail');
    });
};
const PPDaily = {
  getPPDailyList,
  getPPDailyBoatList,
  getPPDailySeatList,
  postAddNewPPDaily,
  getPPDailyIdDetail,
  getPPDailyPreIdDetail,
  putPPDailyIdDetail,
  putPPDailyIdDetailV2,
  deletePPDaily,
  exportPPDailyIdDetail,
};
// 風機點位工進
const getPPFanList = (dispatch, { page, per_page, body }) => {
  const key = 'PPFanList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/fanpoint/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPFanList');
      dispatch(removeLoading(key));
    });
};
const postAddNewPPFan = (dispatch, { body }) => {
  const key = 'PostAddNewPPFan';
  dispatch(setLoading(key));
  axios.post(`${developIp}/fanpoint/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewPPFan');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getPPFanIdDetail = (dispatch, { id }) => {
  const key = 'PPFanIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/fanpoint/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPFanIdDetail');
      dispatch(removeLoading(key));
    });
};
const getPPFanIdList = dispatch => {
  const key = 'PPFanIdList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/adminproc/point_id/windcontract/${wind_id()}/list`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPFanIdList');
      dispatch(removeLoading(key));
    });
};
const putPPFanIdDetail = (dispatch, { id, body }) => {
  const key = 'PutPPFanIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/fanpoint/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putPPFanIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deletePPFan = (dispatch, { id }) => {
  const key = 'DeletePPFan';
  dispatch(setLoading(key));
  axios.put(`${developIp}/fanpoint/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deletePPFan');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
// 風機點位工進 - 海纜
const getPPFanSubmarineList = (dispatch, { page, per_page, body }) => {
  const key = 'PPFanSubmarineList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/cablework/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPFanSubmarineList');
      dispatch(removeLoading(key));
    });
};
const postAddNewPPFanSubmarine = (dispatch, { body }) => {
  const key = 'PostAddNewPPFanSubmarine';
  dispatch(setLoading(key));
  axios.post(`${developIp}/cablework/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewPPFanSubmarine');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getPPFanSubmarineIdDetail = (dispatch, { id }) => {
  const key = 'PPFanSubmarineIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/cablework/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getPPFanSubmarineIdDetail');
      dispatch(removeLoading(key));
    });
};
const putPPFanSubmarineIdDetail = (dispatch, { id, body }) => {
  const key = 'PutPPFanSubmarineIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/cablework/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putPPFanSubmarineIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deletePPFanSubmarine = (dispatch, { id }) => {
  const key = 'DeletePPFanSubmarine';
  dispatch(setLoading(key));
  axios.put(`${developIp}/cablework/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deletePPFanSubmarine');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const PPFan = {
  getPPFanList,
  postAddNewPPFan,
  getPPFanIdDetail,
  getPPFanIdList,
  putPPFanIdDetail,
  deletePPFan,
  getPPFanSubmarineList,
  postAddNewPPFanSubmarine,
  getPPFanSubmarineIdDetail,
  putPPFanSubmarineIdDetail,
  deletePPFanSubmarine,
};
// 本國船舶
const getNativeBoatList = (dispatch, { page, per_page, body = {}, windId }) => {
  const key = 'NativeBoatList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/domesticship/list/${page}/${per_page}/`, { windcontract_id: windId || wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getNativeBoatList');
      dispatch(removeLoading(key));
    });
};
const postAddNewNativeBoat = (dispatch, { body }) => {
  const key = 'PostAddNewNativeBoat';
  dispatch(setLoading(key));
  axios.post(`${developIp}/domesticship/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewNativeBoat');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getNativeBoatIdDetail = (dispatch, { id }) => {
  const key = 'NativeBoatIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/domesticship/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getNativeBoatIdDetail');
      dispatch(removeLoading(key));
    });
};
const putNativeBoatIdDetail = (dispatch, { id, body }) => {
  const key = 'PutNativeBoatIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/domesticship/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putNativeBoatIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteNativeBoat = (dispatch, { id }) => {
  const key = 'DeleteNativeBoat';
  dispatch(setLoading(key));
  axios.put(`${developIp}/domesticship/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteNativeBoat');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const NativeBoat = {
  getNativeBoatList,
  postAddNewNativeBoat,
  getNativeBoatIdDetail,
  putNativeBoatIdDetail,
  deleteNativeBoat,
};
// 外籍船舶
const getBoatStageList = dispatch => { // 國內金融機構融資到位進度
  const key = 'BoatStageList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/ship_stage/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getBoatStageList');
      dispatch(removeLoading(key));
    });
};
const getForeignBoatNationList = dispatch => { // 國內金融機構融資到位進度
  const key = 'ForeignBoatNationList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/nation/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getForeignBoatNationList');
      dispatch(removeLoading(key));
    });
};
const getForeignBoatList = (dispatch, { page, per_page, body, windId }) => {
  const key = 'ForeignBoatList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/foreignship/list/${page}/${per_page}/`, { windcontract_id: windId || wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getForeignBoatList');
      dispatch(removeLoading(key));
    });
};
const postAddNewForeignBoat = (dispatch, { body }) => {
  const key = 'PostAddNewForeignBoat';
  dispatch(setLoading(key));
  axios.post(`${developIp}/foreignship/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewForeignBoat');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getForeignBoatIdDetail = (dispatch, { id }) => {
  const key = 'ForeignBoatIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/foreignship/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getForeignBoatIdDetail');
      dispatch(removeLoading(key));
    });
};
const putForeignBoatIdDetail = (dispatch, { id, body }) => {
  const key = 'PutForeignBoatIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/foreignship/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putForeignBoatIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteForeignBoat = (dispatch, { id }) => {
  const key = 'DeleteForeignBoat';
  dispatch(setLoading(key));
  axios.put(`${developIp}/foreignship/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteForeignBoat');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const ForeignBoat = {
  getBoatStageList,
  getForeignBoatNationList,
  getForeignBoatList,
  postAddNewForeignBoat,
  getForeignBoatIdDetail,
  putForeignBoatIdDetail,
  deleteForeignBoat,
};

// 總覽
const getIAOverviewData = dispatch => {
  const key = 'IAOverviewData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/contract/windcontract/${wind_id()}/summary`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAOverviewData');
      dispatch(removeLoading(key));
    });
};
// 總覽 - 海事工程服務
const getIAOverviewMaritimeList = (dispatch, { page, per_page, body }) => {
  const key = 'IAOverviewMaritimeList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/marineeng/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAOverviewMaritimeList');
      dispatch(removeLoading(key));
    });
};
const exportIAOverviewMaritimeList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/marineeng/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '項目', '細項(組件)', '承包商', '數量(單位)'],
            data: list.map((o, i) => [
              i + 1,
              o.project || '-',
              o.detailitem || '-',
              '-',
              o.apply_change_num || '-',
            ]),
            fileName,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAOverviewMaritimeList');
    });
};
const deleteIAOverviewMaritime = (dispatch, { id }) => {
  const key = 'DeleteIAOverviewMaritime';
  dispatch(setLoading(key));
  axios.put(`${developIp}/marineeng/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAOverviewMaritime');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getIAOMaritimeIdDetail = (dispatch, { id }) => {
  const key = 'IAOMaritimeIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/marineeng/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAOMaritimeIdDetail');
      dispatch(removeLoading(key));
    });
};
const postAddNewIAOMaritimeData = (dispatch, { body }) => {
  const key = 'PostAddNewIAOMaritimeData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/marineeng/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAOMaritimeData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putIAOMaritimeData = (dispatch, { id, body }) => {
  const key = 'PutIAOMaritimeData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/marineeng/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAOMaritimeData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
// 總覽 - 製造業
const getIAOManufacturingList = dispatch => {
  const key = 'IAOManufacturingList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projcontent/windcontract/${wind_id()}/summary`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAOManufacturingList');
      dispatch(removeLoading(key));
    });
};

const IAOverview = {
  getIAOverviewData,
  getIAOverviewMaritimeList,
  exportIAOverviewMaritimeList,
  deleteIAOverviewMaritime,
  getIAOMaritimeIdDetail,
  postAddNewIAOMaritimeData,
  putIAOMaritimeData,
  getIAOManufacturingList,

};
// 相關會議與函文
// 相關會議與函文 - 上傳產發署每月產業關聯執行方案查核報告表
const getIAMeetReportList = (dispatch, { page, per_page, body }) => {
  const key = 'IAMeetReportList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industryreport/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetReportList');
      dispatch(removeLoading(key));
    });
};
const exportIAMeetReportList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/industryreport/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '查核報告表產出日期', '發文日期', '文號', '主旨', '上傳檔案'],
            data: list.map((o, i) => [
              i + 1,
              o.check_report_date,
              o.publication_date,
              o.doc_num,
              o.doc_subject,
              (o.doc_upload_files || []).map(o2 => o2.original_file_name).join('\n'),
            ]),
            fileName,
            wrapText: true,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAMeetReportList');
    });
};
const postAddNewIAMeetReport = (dispatch, { body }) => {
  const key = 'PostAddNewIAMeetReport';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industryreport/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAMeetReport');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getIAMeetReportIdDetail = (dispatch, { id }) => {
  const key = 'IAMeetReportIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/industryreport/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetReportIdDetail');
      dispatch(removeLoading(key));
    });
};
const putIAMeetReportIdDetail = (dispatch, { id, body }) => {
  const key = 'PutIAMeetReportIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industryreport/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAMeetReportIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAMeetReport = (dispatch, { id }) => {
  const key = 'DeleteIAMeetReport';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industryreport/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAMeetReport');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAMeetReport = {
  getIAMeetReportList,
  exportIAMeetReportList,
  postAddNewIAMeetReport,
  getIAMeetReportIdDetail,
  putIAMeetReportIdDetail,
  deleteIAMeetReport,
};
// 相關會議與函文 - 上傳產發署產業關聯審查/追蹤/查核會議之會議紀錄
const getIAMeetRecordList = (dispatch, { page, per_page, body }) => {
  const key = 'IAMeetRecordList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industrymeet/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetRecordList');
      dispatch(removeLoading(key));
    });
};
const exportIAMeetRecordList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/industrymeet/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '發文日期', '文號', '主旨', '上傳檔案'],
            data: list.map((o, i) => [
              i + 1,
              o.publication_date,
              o.doc_num,
              o.doc_subject,
              (o.doc_upload_files || []).map(o2 => o2.original_file_name).join('\n'),
            ]),
            fileName,
            wrapText: true,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAMeetRecordList');
    });
};
const postAddNewIAMeetRecord = (dispatch, { body }) => {
  const key = 'PostAddNewIAMeetRecord';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industrymeet/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAMeetRecord');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getIAMeetRecordIdDetail = (dispatch, { id }) => {
  const key = 'IAMeetRecordIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/industrymeet/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetRecordIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putIAMeetRecordIdDetail = (dispatch, { id, body }) => {
  const key = 'PutIAMeetRecordIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industrymeet/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAMeetRecordIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAMeetRecord = (dispatch, { id }) => {
  const key = 'DeleteIAMeetRecord';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industrymeet/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAMeetRecord');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAMeetRecord = {
  getIAMeetRecordList,
  exportIAMeetRecordList,
  postAddNewIAMeetRecord,
  getIAMeetRecordIdDetail,
  putIAMeetRecordIdDetail,
  deleteIAMeetRecord,
};
// 相關會議與函文 - 上傳經濟部/能源署之產業關聯項目相關函文
const getIAMeetRelatedList = (dispatch, { page, per_page, body }) => {
  const key = 'IAMeetRelatedList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industryitemdoc/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetRelatedList');
      dispatch(removeLoading(key));
    });
};
const exportIAMeetRelatedList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/industryitemdoc/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '發文日期', '文號', '主旨', '上傳檔案'],
            data: list.map((o, i) => [
              i + 1,
              o.publication_date,
              o.doc_num,
              o.doc_subject,
              (o.doc_upload_files || []).map(o2 => o2.original_file_name).join('\n'),
            ]),
            fileName,
            wrapText: true,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAMeetRelatedList');
    });
};
const postAddNewIAMeetRelated = (dispatch, { body }) => {
  const key = 'PostAddNewIAMeetRelated';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industryitemdoc/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAMeetRelated');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getIAMeetRelatedIdDetail = (dispatch, { id }) => {
  const key = 'IAMeetRelatedIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/industryitemdoc/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetRelatedIdDetail');
      dispatch(removeLoading(key));
    });
};
const putIAMeetRelatedIdDetail = (dispatch, { id, body }) => {
  const key = 'PutIAMeetRelatedIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industryitemdoc/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAMeetRelatedIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAMeetRelated = (dispatch, { id }) => {
  const key = 'DeleteIAMeetRelated';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industryitemdoc/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAMeetRelated');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAMeetRelated = {
  getIAMeetRelatedList,
  exportIAMeetRelatedList,
  postAddNewIAMeetRelated,
  getIAMeetRelatedIdDetail,
  putIAMeetRelatedIdDetail,
  deleteIAMeetRelated,
};
// 相關會議與函文 - 行政契約產業關聯追蹤會議
const getIAMeetMeetingList = (dispatch, { page, per_page, body }) => {
  const key = 'IAMeetMeetingList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industrytrack/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetMeetingList');
      dispatch(removeLoading(key));
    });
};
const exportIAMeetMeetingList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/industrytrack/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '類別', '項目', '細項', '辦理情形', '發文日期', '文號', '主旨', '針對辦理情形檢附佐證資料'],
            data: list.map((o, i) => [
              i + 1,
              o.category,
              o.project,
              o.detailitem,
              o.situation,
              o.public_date,
              o.doc_num,
              o.doc_subject,
              (o.doc_upload_files || []).map(o2 => o2.original_file_name).join('\n'),
            ]),
            fileName,
            wrapText: true,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAMeetMeetingList');
    });
};
const getIAMMClassList = dispatch => {
  const key = 'IAMMClassList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/meet_category/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMMClassList');
      dispatch(removeLoading(key));
    });
};
const getIAMMItemList = dispatch => {
  const key = 'IAMMItemList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/industry_proj/`, getHeaders())
    .then(async res => {
      if (res.data.status === '200') {
        const data = res.data.data || [];
        for (let i = 1; i <= data.length; i++) {
          const idList = (await getIAMMItemNumList(i)) || [];
          data[i - 1].idList = idList;
        }
        dispatch({ type: 'post', body: data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMMItemList');
      dispatch(removeLoading(key));
    });
};
const getIAMMItemNumList = num => {
  return new Promise((resolve, reject) => {
    axios.get(`${developIp}/code/items/industry_proj_${num}/`, getHeaders())
      .then(res => {
        if (res.data.status === '200') {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        logError(error, 'getIAMMItemNumList');
        reject(new Error('getIAMMItemNumList() rejected!'));
      });
  });
};
const postAddNewIAMeetMeeting = (dispatch, { body }) => {
  const key = 'PostAddNewIAMeetMeeting';
  dispatch(setLoading(key));
  axios.post(`${developIp}/industrytrack/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAMeetMeeting');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const getIAMeetMeetingIdDetail = (dispatch, { id }) => {
  const key = 'IAMeetMeetingIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/industrytrack/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMeetMeetingIdDetail');
      dispatch(removeLoading(key));
    });
};
const putIAMeetMeetingIdDetail = (dispatch, { id, body }) => {
  const key = 'PutIAMeetMeetingIdDetail';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industrytrack/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAMeetMeetingIdDetail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAMeetMeeting = (dispatch, { id }) => {
  const key = 'DeleteIAMeetMeeting';
  dispatch(setLoading(key));
  axios.put(`${developIp}/industrytrack/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAMeetMeeting');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAMeetMeeting = {
  getIAMeetMeetingList,
  exportIAMeetMeetingList,
  getIAMMClassList,
  getIAMMItemList,
  postAddNewIAMeetMeeting,
  getIAMeetMeetingIdDetail,
  putIAMeetMeetingIdDetail,
  deleteIAMeetMeeting,
};
const IAMeet = { // 相關會議與函文
  ...IAMeetReport, // 上傳經濟部/能源署之產業關聯項目相關函文
  ...IAMeetRecord, // 上傳產發署產業關聯審查/追蹤/查核會議之會議紀錄
  ...IAMeetRelated, // 上傳經濟部/能源署之產業關聯項目相關函文
  ...IAMeetMeeting, // 行政契約產業關聯追蹤會議
};
// 海事工程
const getIAMTPartnerList = dispatch => {
  const key = 'IAMTPartnerList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/partner/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMTPartnerList');
      dispatch(removeLoading(key));
    });
};
const getIAMTEvidenceTypeList = dispatch => {
  const key = 'IAMTEvidenceTypeList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/select_data_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMTEvidenceTypeList');
      dispatch(removeLoading(key));
    });
};
const getIAMTContractDateList = dispatch => {
  const key = 'IAMTContractDateList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/code/items/contract_date_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMTContractDateList');
      dispatch(removeLoading(key));
    });
};
const getIAMaritimeData = dispatch => {
  const key = 'IAMaritimeData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/marineeng/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAMaritimeData');
      dispatch(removeLoading(key));
    });
};
const postAddNewIAMaritimeData = (dispatch, { body }) => {
  const key = 'PostAddNewIAMaritimeData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/marineeng/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAMaritimeData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putIAMaritimeData = (dispatch, { id, body }) => {
  const key = 'PutIAMaritimeData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/marineeng/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAMaritimeData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAMaritime = {
  getIAMaritimeData,
  putIAMaritimeData,
  getIAMTPartnerList,
  getIAMTEvidenceTypeList,
  postAddNewIAMaritimeData,
  getIAMTContractDateList,
};
// 製造業-執行方案 // 製造業-產業關聯執行方案內容
const getIAManufacturingProgramList = (dispatch, { page, per_page, body }) => {
  const key = 'IAManufacturingProgramList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projcontent/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProgramList');
      dispatch(removeLoading(key));
    });
};
const exportIAManufacturingProgramList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/projcontent/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '項目', '細項(組件)', '承包商', '數量(單位)'],
            data: list.map((o, i) => [
              i + 1,
              o.project || '-',
              o.detailitem || '-',
              o.partner || '-',
              o.industry_num || '-',
            ]),
            fileName,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAManufacturingProgramList');
    });
};
const getIAManufacturingProgramIdDetail = (dispatch, { id }) => {
  const key = 'IAManufacturingProgramIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projcontent/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProgramIdDetail');
      dispatch(removeLoading(key));
    });
};
const getIAManufacturingProgramData = dispatch => {
  const key = 'IAManufacturingProgramData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projcontent/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProgramData');
      dispatch(removeLoading(key));
    });
};
const postAddNewIAManufacturingProgramData = (dispatch, { body }) => {
  const key = 'PostAddNewIAManufacturingProgramData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projcontent/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAManufacturingProgramData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putIAManufacturingProgramData = (dispatch, { id, body }) => {
  const key = 'PutIAManufacturingProgramData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projcontent/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAManufacturingProgramData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAManufacturingProgram = (dispatch, { id }) => {
  const key = 'DeleteIAManufacturingProgram';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projcontent/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAManufacturingProgram');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAManufacturingProgram = {
  getIAManufacturingProgramList,
  exportIAManufacturingProgramList,
  getIAManufacturingProgramIdDetail,
  getIAManufacturingProgramData,
  postAddNewIAManufacturingProgramData,
  putIAManufacturingProgramData,
  deleteIAManufacturingProgram,
};
// 製造業-辦理中 // 製造業-目前申請產業關聯項目變更之辦理情形
const getIAManufacturingProcessList = (dispatch, { page, per_page, body }) => {
  const key = 'IAManufacturingProcessList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projchange/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProcessList');
      dispatch(removeLoading(key));
    });
};
const exportIAManufacturingProcessList = ({ page, per_page, body }, fileName = '') => {
  axios.post(`${developIp}/projchange/list/${page}/${per_page}/`, { windcontract_id: wind_id(), ...body, select_all: '1' }, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data?.data?.list || [];
        if (!list.length) alert('無匯出資料');
        else {
          excel.outputAryAry({
            header: ['序號', '項目', '細項(組件)', '承包商', '數量(單位)'],
            data: list.map((o, i) => [
              i + 1,
              o.project || '-',
              o.detailitem || '-',
              o.partner || '-',
              o.industry_num || '-',
            ]),
            fileName,
          });
        }
      }
    })
    .catch(error => {
      logError(error, 'exportIAManufacturingProcessList');
    });
};
const getIAManufacturingProcessIdDetail = (dispatch, { id }) => {
  const key = 'IAManufacturingProcessIdDetail';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projchange/${id}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProcessIdDetail');
      dispatch(removeLoading(key));
    });
};
const getIAManufacturingProcessData = dispatch => {
  const key = 'IAManufacturingProcessData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/projchange/windcontract/${wind_id()}/detail`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getIAManufacturingProcessData');
      dispatch(removeLoading(key));
    });
};
const postAddNewIAManufacturingProcessData = (dispatch, { body }) => {
  const key = 'PostAddNewIAManufacturingProcessData';
  dispatch(setLoading(key));
  axios.post(`${developIp}/projchange/addNew`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'postAddNewIAManufacturingProcessData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const putIAManufacturingProcessData = (dispatch, { id, body }) => {
  const key = 'PutIAManufacturingProcessData';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projchange/${id}/update`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'putIAManufacturingProcessData');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const deleteIAManufacturingProcess = (dispatch, { id }) => {
  const key = 'DeleteIAManufacturingProcess';
  dispatch(setLoading(key));
  axios.put(`${developIp}/projchange/delete/soft`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: key });
    })
    .catch(error => {
      logError(error, 'deleteIAManufacturingProcess');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: key });
    });
};
const IAManufacturingProcess = {
  getIAManufacturingProcessList,
  exportIAManufacturingProcessList,
  getIAManufacturingProcessIdDetail,
  getIAManufacturingProcessData,
  postAddNewIAManufacturingProcessData,
  putIAManufacturingProcessData,
  deleteIAManufacturingProcess,
};

const getGisData = dispatch => {
  const key = 'GisData';
  dispatch(setLoading(key));
  axios.get(`${developIp}/windcontract/location/all`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisData');
      dispatch(removeLoading(key));
    });
};
const getWinds1 = dispatch => {
  const key = 'GisWinds1';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/view/1/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWinds1');
      dispatch(removeLoading(key));
    });
};
const getWinds2 = dispatch => {
  const key = 'GisWinds2';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/view/2/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWinds2');
      dispatch(removeLoading(key));
    });
};
const getWinds3 = dispatch => {
  const key = 'GisWinds3';
  dispatch(setLoading(key));
  axios.get(`${developIp}/docksys/view/3/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data_rows, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWinds3');
      dispatch(removeLoading(key));
    });
};
const getWindsPierList = (dispatch, body = {}) => {
  const key = 'WindsPierList';
  dispatch(setLoading(key));
  axios.post(`${developIp}/docksys/qry/dock/list`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindsPierList');
      dispatch(removeLoading(key));
    });
};

const getWindsBoatList = dispatch => {
  const key = 'WindsBoatList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/ship_info`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindsBoatList');
      dispatch(removeLoading(key));
    });
};

const getWindsBoatListV2 = (dispatch, { body }) => {
  const key = 'WindsBoatListV2';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.post(`${developIp}/frontend/field_ship/ship_info/new/v2/`, body, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        const list = res.data.data || [];
        dispatch({ type: 'post', body: list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindsBoatListV2');
      dispatch(removeLoading(key));
    });
};


const getWindsBoatListV3 = ({ body }) => {
  return axios.post(`${developIp}/frontend/field_ship/ship_info/new/v2/`, body, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        const list = res.data.data || [];
        return list;
      }
    })
    .catch(error => {
      logError(error, 'getWindsBoatListV3');
      return [];
    });
};


const getAllFieldsShipNameList = dispatch => {
  const key = 'AllFieldsShipNameList';
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/ship_names/new/v2/`, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.ship_name, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAllFieldsShipNameList');
      dispatch(removeLoading(key));
    });
};

const getAllFieldsJobs = dispatch => {
  const key = 'AllFieldsJobs';
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/jobs/new/v2/`, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.job, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getAllFieldsJobs');
      dispatch(removeLoading(key));
    });
};


const getWindsForeignBoatList = (dispatch, { id }) => {
  const key = 'WindsForeignBoatList';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/${id}/ship_schedule`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        const list = res.data.data.list || [];
        function getList() {
          const keyWord = '1900/01/01';
          let listWord = JSON.stringify(list);
          while (listWord.match(keyWord)) {
            listWord = listWord.replace(keyWord, '');
          }
          return JSON.parse(listWord);
        }
        dispatch({ type: 'post', body: getList(), label: key });
      }
    })
    .catch(error => {
      logError(error, 'getWindsForeignBoatList');
      dispatch(removeLoading(key));
    });
};

// 工進規劃&實際報表
const getGisPlanReportData = (dispatch, { start_date, end_date, stage }) => {
  const key = 'GisPlanReportData';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/${start_date}/${end_date}/${stage}/get_project_schedule`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.obj, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisPlanReportData');
      dispatch(removeLoading(key));
    });
};

// 工進規劃&實際報表v2
const getGisPlanReportDataV2 = (dispatch, { start_date, end_date, stage }, body) => {
  const key = 'GisPlanReportDataV2';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.post(`${developIp}/frontend/field_ship/${start_date}/${end_date}/${stage}/get_project_schedule/new/v2/`, body, getHeaders())
    .then(res => {
      if (res.data.status === 200 || res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisPlanReportDataV2');
      dispatch(removeLoading(key));
    });
};

// 各項目階段工進期間&累計報表
const getGisStepReportData = (dispatch, { start_date, end_date }) => {
  const key = 'GisStepReportData';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/projectplan/${start_date}/${end_date}/this_week_progress`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisStepReportData');
      dispatch(removeLoading(key));
    });
};
// 單一風場進度綜覽
const getGisWindViewData = (dispatch, { id }) => {
  const key = 'GisWindViewData';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/projectplan/${id}/single_winfield_progress`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisWindViewData');
      dispatch(removeLoading(key));
    });
};
// 每週
const getGisPerWeek = (dispatch, { id }) => {
  const key = 'GisPerWeek';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/projectplan/${id}/weekly_process`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.data, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisPerWeek');
      dispatch(removeLoading(key));
    });
};
// 每月
const getGisPerMonth = (dispatch, { id }) => {
  const key = 'GisPerMonth';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/projectplan/${id}/monthly_process`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getGisPerMonth');
      dispatch(removeLoading(key));
    });
};
// 風機點位工進表
const getFanProjectProcess = (dispatch, { id }) => {
  const key = 'FanProjectProcess';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/${id}/fanpoint_project_process`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getFanProjectProcess');
      dispatch(removeLoading(key));
    });
};
const getFanProjectProcessMap = (dispatch, { id }) => {
  const key = 'FanProjectProcessMap';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/projectplan/${id}/fanpoint_map`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getFanProjectProcessMap');
      dispatch(removeLoading(key));
    });
};
// 風機部件儲放情形
const getFanStore = (dispatch, { id }) => {
  const key = 'FanStore';
  clearKey(dispatch, { key });
  dispatch(setLoading(key));
  axios.get(`${developIp}/frontend/field_ship/${id}/fanpart_storage`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.list, label: key });
      }
    })
    .catch(error => {
      logError(error, 'getFanStore');
      dispatch(removeLoading(key));
    });
};
const Gis = {
  getGisData,
  getWinds: dispatch => {
    getWinds1(dispatch);
    getWinds2(dispatch);
    getWinds3(dispatch);
    getPSPierList(dispatch);
  },
  getWindsPierList,
  getWindsBoatList,

  getWindsBoatListV2,
  getWindsBoatListV3,
  getAllFieldsShipNameList,
  getAllFieldsJobs,

  getWindsForeignBoatList,
  getGisPlanReportData,
  getGisPlanReportDataV2,

  getGisStepReportData,
  getGisWindViewData,
  getGisPerWeek,
  getGisPerMonth,
  getFanProjectProcess,
  getFanProjectProcessMap,
  getFanStore,
};
const actions = {
  clearKey,
  wind_id,
  wind_name,
  getWindIdDetail,
  // 風場合約管理
  ...WindManagement,
  // 基本資料
  ...BasicInfo,
  // 契約內容
  ...AContract,
  // 行政程序
  ...APro,
  // 金融項目
  ...AFinc,
  // 股權變更
  ...AEquity,
  // 展延資訊
  ...Extend,
  // 碼頭系統,
  ...PierSystem,
  // 工程進度
  ...ProjectProgress,
  // 每日進度
  ...PPDaily,
  // 風機點位工進
  ...PPFan,
  // 本國船舶
  ...NativeBoat,
  // 外籍船舶
  ...ForeignBoat,
  // 總覽
  ...IAOverview,
  // 相關會議與函文
  ...IAMeet,
  // 海事工程
  ...IAMaritime,
  // 製造業-執行方案 // 製造業-產業關聯執行方案內容
  ...IAManufacturingProgram,
  // 製造業-辦理中 // 製造業-目前申請產業關聯項目變更之辦理情形
  ...IAManufacturingProcess,
  Gis,
};
export default actions;
